<template>
	<div v-if="show" :class="slideInClass">
		<header>
			<div class="title-container">
				<h4>Welche weitere Software beherrscht du?</h4>
				<div class="close-container">
					<a href="#" @click.prevent="closeFan(false)">
						<Icon icon="close"/>
					</a>
				</div>
			</div>
		</header>
		<main class="scrollbar-check flex-grow-1">
			<JonInfo class="mt-0 mb-4" />
			<div class="sections">
				<section>
					<h3>{{ hasItems ? 'Weitere Software hinzufügen' : 'Jede Software einzeln eingeben' }}</h3>
					<SkillsSoftwareSpecial
						v-model="software"
						meta="meta"
						@hasItems="hasItems = $event"
					/>
				</section>
			</div>
		</main>
		<footer>
			<Button
				text="Fertig"
				:disabled="!software"
				icon="checkmark"
				@click="closeFan(true)"
			/>
		</footer>
		<CompletionCheckPopUp
			v-if="showCompletionCheckPopUp"
			title="Weitere Software"
			ok-button-text="Keine weiteren Kenntnisse"
			@abort="showCompletionCheckPopUp = false"
			@skip="closeFan(true, true)"
			@ok="closeFan(true, false)"
		>
			<template #info>
				<div v-html="completionCheckInfo"/>
			</template>
		</CompletionCheckPopUp>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/application/skill-software-special/fan";
import Button from "@/vue/common/Button.vue";
import SkillsSoftwareSpecial from "@/vue/application/SkillsSoftwareSpecial.vue";
import JonInfo from "./JonInfo";
import {arrayIsNotEmpty} from "@/helper/Array";
import CompletionCheckPopUp from "@/vue/characteristic/completion-check/PopUp.vue";
import {APPLICATION_SOFTWARE_SPECIAL} from "@/helper/characteristic/completion-check/Info";

export default {

	components: {
		CompletionCheckPopUp,
		SkillsSoftwareSpecial,
		Icon,
		Button,
		JonInfo
	},

	data ()
	{
		return {
			hasItems: false,
			showCompletionCheckPopUp: false
		};
	},

	computed: {
		...mapState('application/skillSoftwareSpecial/fan', [
			'show',
		]),
		...mapState('layout', ['fanLevelClasses']),
		...mapState('meta', ['meta']),
		software: {
			get ()
			{
				return this.$store.state.application.skillSoftwareSpecial.fan.software;
			},

			set (v)
			{
				this.setSoftware(v);
			}
		},
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		completionCheckInfo ()
		{
			return APPLICATION_SOFTWARE_SPECIAL;
		}
	},

	methods: {
		...mapActions('application/skillSoftwareSpecial/fan', [
			'close'
		]),
		...mapMutations('application/skillSoftwareSpecial/fan', [
			'setSoftware'
		]),
		closeFan (confirmed, skipped)
		{
			if (!this.showCompletionCheckPopUp && this.hasItems)
			{
				this.showCompletionCheckPopUp = true;
				return;
			}

			this.showCompletionCheckPopUp = false;

			this.close({
				confirmed,
				skipped
			});
		}
	},

	watch: {
		software (v)
		{
			this.hasItems = v && arrayIsNotEmpty(v);
		}
	}
}
</script>
